// extracted by mini-css-extract-plugin
module.exports = {"studioBanner":"WixStudioBanner_studioBanner__Gsxc8","logoWrapper":"WixStudioBanner_logoWrapper__k8fZ9"};